// @flow

export function filterArgentineCashBankCode(incomingPaymentType:?string): string {
  const argentineCashBankCodes = ['rapipago', 'pagofacil', 'cupon'];
  if(incomingPaymentType && argentineCashBankCodes.includes(incomingPaymentType)) {
    return incomingPaymentType;
  }

  return '';
}
